<script>
  import { links, navigate } from "svelte-routing"
  import { onDestroy, onMount } from "svelte"
  import { globalHistory } from "svelte-routing/src/history"
  import { user } from "../stores/User"
  import New from "./New.svelte"
  import { Drawer } from "../services/bootstrap.js"

  let pathname = window.location.pathname
  let unsub
  let drawerElement
  let drawerInstance
  let navigationOpen = false
  let pendingOpen = false
  let synchronizing = false
  let destroyed = false

  const synchronizeNavigation = async (requestedOpen) => {
    pendingOpen = requestedOpen
    if (!drawerElement || synchronizing || destroyed) return
    synchronizing = true
    drawerInstance = Drawer.getOrCreateInstance(drawerElement)
    try {
      while (!destroyed) {
        const nextOpen = pendingOpen
        if (nextOpen) await drawerInstance.show()
        else await drawerInstance.hide()
        if (nextOpen === pendingOpen) break
      }
    } finally {
      synchronizing = false
      if (destroyed) drawerInstance?.dispose()
    }
  }

  $: if (drawerElement) synchronizeNavigation(navigationOpen)

  onMount(() => {
    unsub = globalHistory.listen(({ location }) => {
      pathname = location.pathname
      navigationOpen = false
    })
  })

  onDestroy(() => {
    unsub?.()
    destroyed = true
    if (!synchronizing) drawerInstance?.dispose()
  })

  const logout = () => {
    user.setUser(null)
    navigate("/", { replace: true })
  }
</script>

<div class="contains-inline sticky-top">
  <nav class="navbar lg:navbar-expand bg-white shadow-sm">
    <div class="container-fluid">
      <button
        class="btn-icon navbar-toggler"
        type="button"
        on:click={() => (navigationOpen = !navigationOpen)}
        aria-controls="navbarNav"
        aria-expanded={navigationOpen}
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon" aria-hidden="true" />
      </button>
      <dialog
        bind:this={drawerElement}
        class="drawer drawer-start"
        id="navbarNav"
        aria-label="Navegación"
        on:cancel|preventDefault={() => (navigationOpen = false)}
        on:close={() => (navigationOpen = false)}
      >
        <div class="drawer-header">
          <span class="drawer-title">Navegación</span>
          <button
            type="button"
            class="btn-close"
            on:click={() => (navigationOpen = false)}
            aria-label="Cerrar"
          />
        </div>
        <div class="drawer-body">
          <ul class="navbar-nav" use:links>
            {#if $user.permisos.includes("crm")}
              <li class="nav-item">
                <a
                  class="nav-link"
                  class:active={pathname.includes("/crm")}
                  href="/crm"><New /> CRM</a
                >
              </li>
            {/if}
            {#if $user.permisos.includes("persona")}
              <li class="nav-item">
                <a
                  class="nav-link"
                  class:active={pathname.includes("/persona")}
                  href="/persona">Persona</a
                >
              </li>
            {/if}
            {#if $user.permisos.includes("empresa")}
              <li class="nav-item">
                <a
                  class="nav-link"
                  class:active={pathname.includes("/empresa")}
                  href="/empresa">Empresa</a
                >
              </li>
            {/if}
            {#if $user.permisos.includes("masivo")}
              <li class="nav-item">
                <a
                  class="nav-link"
                  class:active={pathname === "/masivo"}
                  href="/masivo">Masivo</a
                >
              </li>
            {/if}
            {#if $user.permisos.includes("reporte")}
              <li class="nav-item">
                <a
                  class="nav-link"
                  class:active={pathname === "/reporte"}
                  href="/reporte">Reporte</a
                >
              </li>
            {/if}
            {#if $user.permisos.includes("filtro")}
              <li class="nav-item">
                <a
                  class="nav-link"
                  class:active={pathname === "/filtro"}
                  href="/filtro">Filtro</a
                >
              </li>
            {/if}
          </ul>
        </div>
      </dialog>
      <div class="text-end">
        <div class="small">
          <p class="mb-0 fg-secondary">
            <i class="bi bi-buildings" />
            {$user.razon_social}
          </p>

          <div class="btn-group">
            <button
              type="button"
              class="btn btn-sm"
              data-bs-toggle="menu"
              data-bs-placement="bottom-end"
              aria-expanded="false"
            >
              <span class="avatar">
                <img
                  class="avatar-img"
                  src="https://github.com/mdo.png"
                  alt="mdo"
                />
              </span>
              {$user.nombres}
            </button>
            <div class="menu text-end" use:links>
              {#if $user.permisos.includes("configuracion")}
                <a class="menu-item" href="/configuracion">
                  <span class="small">Cambiar clave</span>
                  <i class="bi bi-gear-fill" />
                </a>
              {/if}
              <button
                class="menu-item fg-danger"
                on:click={logout}
                type="button"
              >
                <span class="small">Cerrar sesión</span>
                <i class="bi bi-box-arrow-right" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</div>
